// eslint-disable-next-line import/prefer-default-export
export const OKTA_TYPE_KEY = 'okta';
